import { render, staticRenderFns } from "./ReadPoliciesModal.vue?vue&type=template&id=7fa71537&scoped=true&"
import script from "./ReadPoliciesModal.vue?vue&type=script&lang=js&"
export * from "./ReadPoliciesModal.vue?vue&type=script&lang=js&"
import style0 from "./ReadPoliciesModal.vue?vue&type=style&index=0&id=7fa71537&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa71537",
  null
  
)

export default component.exports